/** Top-level: no site ID or environment. */
export const HELP_PATH = '/help';

/** Site-scoped but env-agnostic, like the other `/settings/*` routes. */
export const TEAM_PATH = '/settings/team';

/** Deep-links a header action to the product tour on a full page load. */
export const PRODUCT_TOUR_ID = '305711';

export const DOCS_URLS = {
  dashboardConfigurations: 'https://docs.sparklayer.io/dashboard-configurations#JJHwx',
  frontendIntegration: 'https://docs.sparklayer.io/frontend-integration',
  frontendChecklist: 'https://docs.sparklayer.io/frontend-integration#Q75Ee',
  frontendConfigurations: 'https://docs.sparklayer.io/configurations',
  gettingStarted: 'https://docs.sparklayer.io/getting-started',
  installingShopify: 'https://docs.sparklayer.io/installing-shopify-sparklayer#IRy0D',
  installingBigcommerce: 'https://docs.sparklayer.io/installing-bigcommerce-sparklayer#JFyuM',
  installingWix: 'https://docs.sparklayer.io/installingwix#JFyuM',
  managingPricing: 'https://docs.sparklayer.io/managing-pricing',
  quantityPricing: 'https://docs.sparklayer.io/quantity-pricing',
  troubleshooting: 'https://docs.sparklayer.io/troubleshooting',
  customerTags: 'https://docs.sparklayer.io/customers#yGzhS',
  inviteCustomers: 'https://docs.sparklayer.io/customers#HIB-b',
  onboardingChecklist: 'https://docs.sparklayer.io/onboarding',
  shopify: 'https://docs.sparklayer.io/shopify',
} as const;
